import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "UIHint" }
const _hoisted_2 = {
  key: 0,
  class: "UIHint-Input"
}
const _hoisted_3 = {
  key: 1,
  class: "UIHint-Calculate"
}
const _hoisted_4 = {
  key: 2,
  class: "UIHint-Reset"
}



type Props = {
	isCheckCalculateAvailable: boolean;
	isCheckResetAvailable: boolean;
	isInterval: boolean;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    isCheckCalculateAvailable: { type: Boolean },
    isCheckResetAvailable: { type: Boolean },
    isInterval: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	isCheckCalculateAvailable: boolean;
	isCheckResetAvailable: boolean;
	isInterval: boolean;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!props.isInterval && !props.isCheckCalculateAvailable)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "半角数字で入力してください。"))
      : _createCommentVNode("", true),
    (props.isCheckCalculateAvailable)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "計算できます。"))
      : _createCommentVNode("", true),
    (props.isInterval && props.isCheckResetAvailable)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "再計算のためにはリセットしてください。"))
      : _createCommentVNode("", true)
  ]))
}
}

})